import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { MultiLanguageUrl } from '../../constants/multiLanguage.constant';

type Props = {
  to: string;
  children: any;
};

export default function UILinkTo({ children, to, ...props }: Props | any) {
  const { t, i18n } = useTranslation();

  if ((to as string)?.length > 0 && to != '') {
    return (
      <Link {...props} replace to={`${import.meta.env.VITE_UI_ADDRESS}/${MultiLanguageUrl[i18n.language] || 'en-US'}/${to}`}>
        {children}
      </Link>
    );
  } else {
    return (
      <Link {...props} replace to={`${import.meta.env.VITE_UI_ADDRESS}/${MultiLanguageUrl[i18n.language] || 'en-US'}`}>
        {children}
      </Link>
    );
  }
}
